/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Public_No_PathsInputs */

const vi_grower_area_public_no_paths = /** @type {(inputs: Grower_Area_Public_No_PathsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vùng trồng này chưa được khoanh toạ độ trên bản đồ.`)
};

/**

* @param {Grower_Area_Public_No_PathsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_public_no_paths = /** @type {((inputs?: Grower_Area_Public_No_PathsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Public_No_PathsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_public_no_paths(inputs)
});